<script setup lang="ts">
const props = withDefaults(defineProps<{ min?: number; max?: number }>(), { min: 0, max: 99 });

const count = defineModel<number>('count', {
  required: true,
  set(value) {
    if (value >= props.max) value = props.max;
    if (value <= props.min) value = props.min;
    return value;
  },
});
</script>

<template>
  <div class="counter-container">
    <div class="count-title">
      <slot name="title"></slot>
    </div>
    <div class="counter">
      <button class="negative" @click="count--"></button>
      <div class="count">
        {{ count }}
      </div>
      <button class="positive" @click="count++"></button>
    </div>
  </div>
</template>

<style lang="scss">
.counter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;

  .count-title {
    p,
    h5 {
      margin: 0;
      padding: 0;
    }
  }

  .counter {
    display: flex;
    align-items: center;
    gap: 4px;

    .count {
      width: 32px;
      height: 32px;
      text-align: center;
    }

    .negative,
    .positive {
      display: flex;
      padding: 4px;
      align-items: flex-start;
      border-radius: 110px;
      background: var(--main);
      border: none;
      gap: 4px;
    }

    .negative {
      &:after {
        content: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="plus-medium 1"><path id="Vector" d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>');
        width: 24px;
        height: 24px;
      }
    }

    .positive {
      &:after {
        content: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="plus-medium 1"><path id="Vector" d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M12 19V5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>');
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
